export const OPEN_SUBSCRIPTION_CHANGE_STATUSES = Object.freeze([
  'pending',
  'payment_method_pending',
  'scheduling',
  'service_grace',
  'scheduled',
  'manual_review',
]);

export function getDetachedOpenSubscriptionChanges(changes = [], subscriptions = []) {
  const visibleSubscriptionIds = new Set(subscriptions.map((subscription) => String(subscription.id)));
  return changes.filter((change) =>
    OPEN_SUBSCRIPTION_CHANGE_STATUSES.includes(change.status)
    && !visibleSubscriptionIds.has(String(change.source_subscription_id))
  );
}
